import { cn } from '../../utils/cn';

/**
 * Badge component for status indicators and labels.
 *
 * @param {Object} props
 * @param {'default'|'primary'|'success'|'warning'|'error'} [props.variant='default'] - Color variant
 * @param {'sm'|'md'} [props.size='md'] - Badge size
 * @param {string} [props.className] - Additional classes
 */
export function Badge({
  variant = 'default',
  size = 'md',
  className,
  children,
  ...props
}) {
  const variants = {
    default: 'bg-neutral-100 text-neutral-700',
    primary: 'bg-primary-100 text-primary-700',
    success: 'bg-success-100 text-success-700',
    warning: 'bg-warning-100 text-warning-700',
    error: 'bg-error-100 text-error-700',
  };

  const sizes = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2 py-1 text-xs',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center font-medium rounded-full',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
